import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useClientAuth } from "@/context/ClientAuth";
import { AuthShell, field, goldBtn } from "@/pages/Login";

function formatErr(detail) {
  if (!detail) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function Signup() {
  const { register } = useClientAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const valid = name.trim() && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) && password.length >= 6;

  const submit = async () => {
    if (!valid) {
      toast.error("Enter a name, valid email and a 6+ char password");
      return;
    }
    setBusy(true);
    try {
      await register(name.trim(), email.trim().toLowerCase(), password);
      toast.success("Account created");
      nav("/dashboard");
    } catch (e) {
      toast.error(formatErr(e.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell tag="Members" title="Create account" footer={<>Already a member? <Link to="/login" className="text-[#D4AF37]">Sign in</Link></>}>
      <input data-testid="signup-name" placeholder="Full name" value={name} onChange={(e) => setName(e.target.value)} className={field} />
      <input data-testid="signup-email" type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className={field} />
      <input data-testid="signup-password" type="password" placeholder="Password (6+ characters)" value={password}
        onChange={(e) => setPassword(e.target.value)} onKeyDown={(e) => e.key === "Enter" && submit()} className={field} />
      <button data-testid="signup-submit" onClick={submit} disabled={busy} className={goldBtn}>
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Sign up"}
      </button>
    </AuthShell>
  );
}
